import { MouseEvent, ReactNode } from "react";
import useHover from "../../hooks/useHover";

interface ConversationCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  onClick?: () => void;
  onDelete?: () => void;
}

function ConversationCard({
  title,
  description,
  icon,
  onClick,
  onDelete,
}: ConversationCardProps) {
  const [itemRef, isHovered] = useHover<HTMLDivElement>(false, !onDelete);

  return (
    <div
      className="d-flex my-2 p-2 border rounded-sm align-items-center cursor-pointer btn-oauth bg-dropdown-hover--hover"
      onClick={onClick}
      style={{ position: "relative" }}
      ref={itemRef}
    >
      {icon && icon}
      {onDelete && isHovered && (
        <i
          className="mdi mdi-close text-white d-flex justify-content-center align-items-center bg-secondary"
          onClick={handleDelete}
          style={{
            fontSize: 16,
            position: "absolute",
            right: -8,
            top: -6,
            lineHeight: 1,
            borderRadius: "50%",
            padding: 2,
          }}
        />
      )}
      <div
        className="font-weight-500 text-dark text-truncate ml-2"
        style={{ fontSize: 15, lineHeight: 1.1, marginTop: 2 }}
      >
        {title}

        <div
          className="text-medium"
          style={{ fontSize: 12, lineHeight: "unset", paddingBottom: 2 }}
        >
          {description}
        </div>
      </div>
    </div>
  );

  function handleDelete(e: MouseEvent<any>) {
    e.stopPropagation();
    onDelete && onDelete();
  }
}

export default ConversationCard;
